import React from 'react';
import ExpenseList from '../components/expenses/ExpenseList';

const ExpensesPage = () => {
    return <ExpenseList />;
};

export default ExpensesPage;